import { useReducer } from 'react';

export const useForceUpdate = () => {
  const [, forceUpdate] = useReducer((count: number) => count + 1, 0);
  return forceUpdate;
};
